import React, {Fragment} from 'react';
import { Helmet } from 'react-helmet';
import NewsLetter from "../../components/NewsLetter";
import Footer from "../../components/Footer";
import ContactInfoList from "../../components/ContactInfoList";
import ContactUs from "../../components/ContactUs";
import BreadCrumb from "../../components/BreadCrumb";



import './style.scss';

const ContactUsPage = () => {
    return(
        <Fragment>
            <Helmet>
            <title>Contact Us</title>
            <meta name="description" content="Todos!" />
         </Helmet>
            <BreadCrumb
                pagename=" "
                title="Contact OneTwoPay"
            />
            <ContactInfoList/>
            <ContactUs/>
            <NewsLetter
                className="pt-0"
            />
            <Footer/>
        </Fragment>
    )
};

export default ContactUsPage;